import FormUtils from './utils/FormUtils';

export default class Form {
	initialFormData = {};
	// scatena i change dei campi form al keyup in modo da non dover levare il focus
	dispatchChangeTimeout = null;

	needsConfirm = false;

	constructor() {
		this.initializeEvents();
		this.initializeFormConfigurator();
		this.initializeSeoChecker();
		this.initializeSummernote();
	}

	// setConfirmPageLeave() {
	// 	this.needsConfirm = true;
	// 	window.needsConfirm = true;
	// 	this._boundAskConfirmPageLeave = this._boundAskConfirmPageLeave ?? this.askConfirmPageLeave.bind(this);
	// 	window.addEventListener('beforeunload', this._boundAskConfirmPageLeave);
	// }

	// askConfirmPageLeave(e) {
	// 	const confirmationMessage = 'Sei sicuro di voler uscire? Le modifiche non salvate andranno perse.';
	// 	e.returnValue = confirmationMessage;
	// 	return confirmationMessage;
	// }

	// clearConfirmPageLeave() {
	// 	this.needsConfirm = false;
	// 	window.needsConfirm = false;
	// 	const handler = this._boundAskConfirmPageLeave ?? this.askConfirmPageLeave;
	// 	window.removeEventListener('beforeunload', handler);
	// }

	setConfirmPageLeave() {
		this.needsConfirm = true;
		window.addEventListener('beforeunload', this.askConfirmPageLeave);
	}

	askConfirmPageLeave(e) {
		const confirmationMessage = 'Sei sicuro di voler uscire? Le modifiche non salvate andranno perse.';
		e.returnValue = confirmationMessage;
		return confirmationMessage;
	}

	clearConfirmPageLeave() {
		window.removeEventListener('beforeunload', this.askConfirmPageLeave);
	}

	captureInitialFormData() {
		this.initialFormData = {};
		$('#pageForm').find(':input[id]:not(button)').each((_idx, element) => {
			const input = $(element);
			let value = input.val();
			if (Array.isArray(value)) {
				value = JSON.stringify(value);
			}
			this.initialFormData[input.attr('id')] = value;
		});
	}

	/**
	 * Shows custom leave-confirm modal (Annulla / Esci senza salvare / Salva ed esci).
	 * Used when user clicks #close with unsaved changes; browser beforeunload cannot be customized.
	 */
	showLeaveConfirmModal(closeHrefOrPopup) {
		const self = this;
		bootbox.dialog({
			title: 'Modifiche non salvate',
			message: 'Vuoi uscire dalla pagina? Le modifiche non salvate andranno perse. Puoi salvare prima di uscire.',
			closeButton: true,
			buttons: {
				cancel: {
					label: 'Annulla',
					className: 'btn-default',
					callback() {
						// Keep user on page; do nothing
					},
				},
				leave: {
					label: 'Esci senza salvare',
					className: 'btn-danger',
					callback() {
						self.clearConfirmPageLeave();
						if (typeof closeHrefOrPopup === 'string' && closeHrefOrPopup) {
							window.location.href = closeHrefOrPopup;
							return;
						}
						// Popup: unlock and notify parent
						const $unlock = $('#unlockurl');
						if ($unlock.length) {
							if (window.Utils?.LoaderShow) window.Utils.LoaderShow();
							if (window.pollingInterval) {
								clearInterval(window.pollingInterval);
								window.pollingInterval = null;
							}
							if (window.pollingCall) {
								window.pollingCall.abort("Annullato dall'utente");
								window.pollingCall = null;
							}
							$.ajax($unlock.val()).then(() => window.parent.postMessage('allowClose', '*'));
						} else {
							window.parent.postMessage('allowClose', '*');
						}
					},
				},
				saveAndLeave: {
					label: 'Salva ed esci',
					className: 'btn-primary',
					callback() {
						// self.clearConfirmPageLeave();
						const $save = $('#save');
						const $popupSave = $('#popupsave');
						const $btn = $save.length ? $save : $popupSave;
						if ($btn.length && !$btn.prop('disabled')) {
							if (typeof closeHrefOrPopup === 'string' && closeHrefOrPopup) {
								const closeUri = new URL(closeHrefOrPopup, window.location.origin);
								const closeBackUrl = closeUri.searchParams.get('back');
								if (closeBackUrl) {
									const originalFormAction = $('#pageForm').attr('action');
									const formUri = new URL(originalFormAction, window.location.origin);
									if (closeBackUrl !== originalFormAction) {
										window.originalFormAction = originalFormAction;
										formUri.searchParams.set('back', closeBackUrl);
										$('#pageForm').attr('action', formUri.toString());
									}
								}
							}
							$btn[0].click();
						}
					},
				},
			},
		});
	}

	/**
	 * Returns true if the link would navigate away from the current page (not same-page anchor, not new tab).
	 */
	isNavigationLink(link) {
		const href = link.getAttribute('href');
		if (!href || href === '#' || href.startsWith('#')) return false;
		if (link.target === '_blank' || link.target === '_new') return false;
		if (link.hasAttribute('data-no-confirm-leave')) return false;
		// Lightbox anchors (editor image/gallery, previews): not real navigation — do not show leave modal
		const lightbox_link_classes = [
			'popup-preview-image',
			'popup-preview-gallery-image',
			'popup-preview-video',
			'popup-preview-iframe',
		];
		if (lightbox_link_classes.some((cls) => link.classList.contains(cls))) return false;
		return true;
	}

	/**
	 * Resolves link href to absolute URL for later navigation.
	 */
	getLinkDestination(link) {
		return link.href;
	}

	/**
	 * Handles #close click: if there are unsaved changes, show custom modal instead of navigating.
	 */
	handleCloseClick(e) {
		if (!this.needsConfirm) return;
		e.preventDefault();
		e.stopPropagation();
		const $close = $('#close');
		const href = $close.attr('href');
		const isPopup = $close.data('is-in-popup') === true || $close.data('is-in-popup') === 'true';
		this.showLeaveConfirmModal(isPopup || !href ? null : href);
	}

	/**
	 * Handles clicks on any link that would navigate away: intercept when needsConfirm, show modal, store destination URL.
	 */
	handleNavigationClick(e) {
		if (!this.needsConfirm) return;
		const link = e.target.closest('a');
		if (!link) return;
		// #close has its own handler (knows popup vs href); skip here to avoid double handling
		if (link.id === 'close') return;
		if (!this.isNavigationLink(link)) return;
		e.preventDefault();
		e.stopPropagation();
		const destination = this.getLinkDestination(link);
		this.showLeaveConfirmModal(destination);
	}

	initializeSummernote() {
		const $summernoteFields = $('textarea[data-plugin="summernote"]');
		if ($summernoteFields.length === 0) return;
		const originalIs = $.fn.is;
		$.fn.is = function (selector) {
			if (selector === ':visible' || selector === ':hidden' || selector === ':not(:visible)') {
				const $this = this;
				if ($this.length > 0 && $this.is('textarea[data-plugin="summernote"]')) {
					// Per i campi Summernote, controlla se l'editor è visibile
					const $editor = $this.next('.note-editor');
					if ($editor.length > 0) {
						const isEditorVisible = $editor.is(':visible');
						if (selector === ':visible') {
							return isEditorVisible;
						} else if (selector === ':hidden') {
							return !isEditorVisible;
						} else if (selector === ':not(:visible)') {
							return !isEditorVisible;
						}
					}
				}
			}
			// Per tutti gli altri casi, usa il metodo originale
			return originalIs.call(this, selector);
		};
		// inizializzazione campi editor summernote
		$summernoteFields.each((_idx, elem) => {
			const $element = $(elem);
			elem.checkValidity = () => {
				const excludeds = $('#pageForm')?.data('formValidation')?.options?.excluded || [];
				for (const excluded of excludeds) {
					if ($element.is(excluded)) return true;
				}
				return !$element.summernote('isEmpty');
			};
			const maxLength = $element.attr('data-seo-max');
			const summernoteOptions =
				window.summernoteOptions !== undefined
					? window.customSummernoteOptions.buttons !== undefined || window.customSummernoteOptions.toolbar !== undefined
						? window.customSummernoteOptions
						: window.customSummernoteOptions[$element.attr('id')]
					: {
							height: 150,
							toolbar: [
								['style', ['bold', 'italic', 'underline']],
								['para', ['ul', 'paragraph']],
								['insert', ['link', 'hr']],
							],
							popover: {
								image: [['remove', ['removeMedia']]],
							},
						};
			const options = Object.assign(summernoteOptions, {
				lang: 'it-IT',
				callbacks: {
					onDialogShown: () => {
						// Check if the dialog is the link dialog
						const linkDialog = $('.modal.note-modal.link-dialog.show');

						// If the link dialog is found
						if (linkDialog.length) {
							// Locate the checkbox div and uncheck/hide the checkbox
							const protocolCheckboxDiv = linkDialog.find('.checkbox.sn-checkbox-use-protocol');
							const protocolCheckbox = protocolCheckboxDiv.find('input[type="checkbox"]');

							// Uncheck the checkbox and hide the whole div
							protocolCheckbox.prop('checked', false).removeAttr('checked');
							protocolCheckbox.attr('aria-checked', 'false'); // Update the aria-checked attribute as well
							protocolCheckboxDiv.hide();

							// Clear the interval once we've made the modification
						}
					},
				},
			});

			if (maxLength) {
				options.callbacks.onKeydown = (e) => {
					var t = e.currentTarget.innerText;
					if (t.length >= maxLength && e.keyCode != 8) e.preventDefault();
				};
				options.callbacks.onKeyup = (e) => {
					var t = e.currentTarget.innerText;
					if (typeof callbackMax == 'function') {
						callbackMax(maxLength - t.length);
					}
				};
				options.callbacks.onPaste = (e) => {
					var t = e.currentTarget.innerText;
					var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
					e.preventDefault();
					var all = t + bufferText;
					document.execCommand('insertText', false, all.trim().substring(0, maxLength));
					if (typeof callbackMax == 'function') {
						callbackMax(maxLength - t.length);
					}
				};
			}

			$element
				.summernote(options)
				.on('summernote.paste', (_e, ne) => {
					var bufferText = ((ne.originalEvent || ne).clipboardData || window.clipboardData).getData('Text');
					ne.preventDefault();
					document.execCommand('insertText', false, bufferText);
				})
				.on('summernote.change', (e) => {
					// SINCRONIZZA il contenuto di Summernote nel textarea nascosto
					const $textarea = $(e.target);
					const content = $textarea.summernote('code');
					// Mantieni l'HTML nel textarea, non rimuoverlo
					$textarea.val(content);
					$textarea.trigger('change');
					const $pageForm = $('#pageForm');
					if ($pageForm) $pageForm.formValidation('revalidateField', $textarea.attr('name') || $textarea.attr('id'));
					// Forza il flag needsConfirm quando Summernote cambia
					this.formChangeHandler(e, true);
				});
		});
	}

	initializeFormConfigurator() {
		// CONFIGURATORE CAMPI FORMS
		if ($('.field-configurator').length) {
			$('.field-configurator').on('click', (e) => {
				const fieldName = e.currentTarget.getAttribute('data-field-identifier');
				const fieldConfigs = FormConfigs.find((field) => field.identifier === fieldName);
				if (!fieldConfigs) return;

				FormUtils.openFormFieldConfigurator(fieldConfigs);
			});
		}
	}

	initializeSeoChecker() {
		// gestione campi con proprietà max/min
		const seocheker = {
			init: () => {
				$('input[data-seo-max]').each((_index, e) => {
					seocheker.trig(e);
					$(e).keyup((e) => seocheker.trig(e.currentTarget));
				});
			},

			trig: (e) => {
				const fieldContainer = $(e).closest('.panel-body');
				let seocurrent = fieldContainer.find('.seo-current');
				let seodelta = fieldContainer.find('.seo-delta');

				let current = e.value.length;

				seocurrent.text(current);

				if (current < $(e).data('seo-min')) {
					seodelta.text(current - $(e).data('seo-min'));
					seodelta.addClass('text-danger');
				} else if (current > $(e).data('seo-max')) {
					seodelta.text('+' + (current - $(e).data('seo-max')));
					seodelta.addClass('text-danger');
				} else {
					seodelta.removeClass('text-danger').addClass('text-success');
					seodelta.text('OK');
				}
			},
		};
		seocheker.init();
	}

	initializeEvents() {
		const pageForm = $('#pageForm');
		// Intercept #close in capture phase so custom leave modal runs before inline onclick
		const closeEl = document.getElementById('close');
		if (closeEl) {
			closeEl.addEventListener('click', (e) => this.handleCloseClick(e), true);
		}
		// Intercept any navigation link click to show leave-confirm modal and store destination URL
		document.addEventListener('click', (e) => this.handleNavigationClick(e), true);

		pageForm.find(':input[id]:not(button):visible').on('keyup', (e) => {
			if (this.dispatchChangeTimeout) {
				clearTimeout(this.dispatchChangeTimeout);
				this.dispatchChangeTimeout = null;
			}

			this.dispatchChangeTimeout = setTimeout(() => {
				$(e.currentTarget).trigger('change');
				this.dispatchChangeTimeout = null;
			}, 500);
		});

		// finchè non cambio qualcosa il plsante salva è spento
		$('#save, #popupsave').prop('disabled', true);

		pageForm.on('change', (e) => this.formChangeHandler(e));
		$('.switchery:not(#form-editing-mode)').on('click', (e) => this.formChangeHandler(e));

		$('button[type="submit"]').on('click', (e) => {
			const $btn = $(this);
			// Distinguish real user click from programmatic click (e.g. "Salva ed esci" modal)
			const is_user_click = (e.originalEvent ?? e).isTrusted === true;
			// Se il pulsante ha già la classe 'submitting', blocca il click
			if ($btn.hasClass('submitting')) {
				e.preventDefault();
				return false;
			}
			this.clearConfirmPageLeave();

			if (is_user_click && window.originalFormAction && window.originalFormAction !== pageForm.attr('action')) {
				pageForm.attr('action', window.originalFormAction);
				window.originalFormAction = null;
			}

			const backButton = $('#close');
			if (!this.needsConfirm && backButton.length) {
				if (backButton.attr('href')) {
					window.location.href = backButton.attr('href');
				} else {
					backButton.trigger('click');
				}
				return false;
			} else {
				$btn.addClass('submitting');
				if (!$('#save i').hasClass('fa-spinner')) $('#save i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
				if (!$('#popupsave i').hasClass('fa-spinner')) $('#popupsave i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
				$btn.css({
					cursor: 'not-allowed',
					opacity: '0.75',
				});
				return true;
			}
		});

		// abilita la modalità di modifica del form
		$('#form-editing-mode.switchery').on('click', () => {
			pageForm.toggleClass('editing-mode');
		});

		// Capture initial form values
		pageForm.find(':input[id]:not(button)').each((_idx, element) => {
			const input = $(element);
			let value = input.val();
			if (Array.isArray(value)) {
				value = JSON.stringify(value);
			}
			this.initialFormData[input.attr('id')] = value;
		});

		setTimeout(() => {
			$('#save,#popupsave').prop('disabled', true);
		}, 1000);
	}

	validateFormFields() {
		const requiredFields = $('#pageForm :input[required]');
		let allFieldsValid = true;

		requiredFields.each((_idx, element) => {
			if (!element.checkValidity()) {
				allFieldsValid = false;
				return false;
			}
		});

		if (allFieldsValid) {
			$('#save, #popupsave').prop('disabled', false);
			// $('#additional-contents .invalid-feedback').hide();
		} else {
			$('#save, #popupsave').prop('disabled', true);
			if ($('#save i').hasClass('fa-spinner')) $('#save i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
			if ($('#popupsave i').hasClass('fa-spinner')) $('#popupsave i').toggleClass('fa-floppy-disk fa-spinner fa-spin');
			// $('#additional-contents .invalid-feedback').show();
		}
		return allFieldsValid;
	}

	async formChangeHandler(evt, forced = false) {
		const allFieldsValid = this.validateFormFields();

		// Check if any field has changed
		let formChanged = forced;
		const $pageForm = $('#pageForm');

		if (!forced && !this.needsConfirm) {
			$pageForm
				.find(
					':input[id]:not(button):visible, :input[id][data-ace-editor-sync]:not(button), .switchery:not(#form-editing-mode):visible, #crop_updated, #editor_updated, #crop_caption',
				)
				.each((_idx, element) => {
					const input = $(element);
					let currentValue = undefined;
					// TODO: non mi piace ma non so come altro fare
					if (input.hasClass('switchery')) {
						currentValue = input.css('background-color') !== 'rgb(255, 255, 255)';
					} else if (['checkbox', 'radio'].includes(input.attr('type'))) {
						currentValue = $(`input:checked[name="${input.attr('name')}"]`)
							.map((_idx, el) => el.value)
							.toArray();
					} else {
						currentValue = input.val();
					}
					const id = input.attr('id');
					let initialValue = this.initialFormData[id];

					if (Array.isArray(currentValue)) {
						currentValue = JSON.stringify(currentValue);
					}

					if (currentValue !== initialValue) {
						formChanged = true;
						return false; // Break the loop
					}
				});
		} else if (this.needsConfirm) {
			// Se il form è già stato modificato, consideriamo sempre formChanged = true
			formChanged = true;
		}

		// If form has changed, validate and set needsConfirm
		if (formChanged) {
			if (!this.needsConfirm) {
				this.setConfirmPageLeave();
			}

			// Validate the form
			await $pageForm.formValidation('validate');

			const $isValidationOk = $pageForm.data('formValidation').isValid();
			if ($isValidationOk && allFieldsValid) {
				$('#save, #popupsave').prop('disabled', false);
			} else {
				const errors = [];
				$pageForm
					.data('formValidation')
					.getInvalidFields()
					.each((_idx, element) => {
						errors.push(element.getAttribute('id') + ' - ' + element.validationMessage);
					});
				console.warn('Form is not valid', errors);
				$('#save, #popupsave').prop('disabled', true);
			}
		}
	}
}
